const styles = theme => ({
  inputRoot: {
    ...theme.typography.body2,
    backgroundColor: theme.palette.background.paper,
    '& $input': {
      width: '100%'
    },
    '&[class*="MuiOutlinedInput-root"]': {
      padding: theme.spacing(1.5),
      '& $input': {
        padding: '8px 0px 4px 0px'
      }
    },
    borderRadius: 0,
    '&:hover $notchedOutline :not(:focus)': {
      borderColor: theme.palette.grey[600]
    }
  },
  notchedOutline: {},
  input: {},
  tag: {
    borderRadius: 2,
    margin: '0px 8px 8px 0px'
  },
  paper: {
    ...theme.typography.body2
  },
  clearIndicator: {
    color: theme.palette.grey[600],
    '& svg': {
      fontSize: '1rem'
    }
  },
  popupIndicator: {
    color: '#006CAA', // configure for theme
    width: theme.spacing(3),
    height: theme.spacing(3)
  },
  clearIndicatorDirty: {
    visibility: 'visible'
  },
  endAdornment: {
    top: theme.spacing(1.5),
    right: theme.spacing(1.5),
    height: theme.spacing(4),
    display: 'flex',
    alignItems: 'center'
  },
  formHelperMessage: {
    display: 'flex',
    alignItems: 'flex-end',
    marginTop: theme.spacing(2.25),
    marginLeft: 0,
    '& svg': {
      fontSize: '1.5rem',
      marginRight: 10
    },
    ...theme.typography.body2
  },
  option: {
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
    '&[data-focus="true"]': {
      backgroundColor: '#DCF3F9',
      borderColor: 'transparent'
    }
  },
  renderTags: props => ({
    maxHeight: props.maxRowsBeforeScroll * 40,
    overflowY: 'auto'
  })
});
export default styles;
